<template>
  <span class="material-design-icon pivot-icon"
        role="img">
    <svg class="material-design-icon__svg"
         :width="customWidth"
         :height="customHeight"
         viewBox="0 0 24 24"
         :fill="fillColor">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 1.6a7.4 7.4 0 1 1 0 14.8 7.4 7.4 0 0 1 0-14.8z"/>
      <rect x="11.35" y="3.6" width="1.3" height="8.4" rx="0.65"/>
      <circle cx="12" cy="7.6" r="1"/>
      <circle cx="12" cy="4" r="1.3"/>
      <circle cx="12" cy="12" r="2.1"/>
    </svg>
  </span>
</template>

<script>
  export default {
    name: "pivot-icon",
    props: ['fillColor', 'customWidth', 'customHeight']
  }
</script>
